import { render } from "./ViewOrganiser.vue?vue&type=template&id=591ba6e2&scoped=true"
import script from "./ViewOrganiser.vue?vue&type=script&lang=js"
export * from "./ViewOrganiser.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=591ba6e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591ba6e2"]])

export default __exports__